var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { display: "inline-block" } }, [
    _vm.buttonsize === undefined
      ? _c(
          "button",
          {
            staticClass: "btn btn-sm btn-primary no-border ",
            staticStyle: { border: "none" },
            on: { click: _vm.follow },
          },
          [
            _vm.following === false
              ? _c("span", [
                  _vm._v(_vm._s(_vm.__("globals.follow")) + " "),
                  _c("i", { staticClass: "feather icon-user-plus" }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.following === true
              ? _c("span", [
                  _vm._v(_vm._s(_vm.__("globals.unfollow")) + " "),
                  _c("i", { staticClass: "feather icon-log-out" }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.following === "pending"
              ? _c("span", [
                  _vm._v(_vm._s(_vm.__("globals.requested")) + " "),
                  _c("i", { staticClass: "feather icon-log-in" }),
                ])
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.buttonsize === "large"
      ? _c(
          "button",
          {
            staticClass: "btn btn-primary no-border ",
            staticStyle: { border: "none" },
            on: { click: _vm.follow },
          },
          [
            _vm.following === false
              ? _c("span", [
                  _vm._v(_vm._s(_vm.__("globals.follow")) + " "),
                  _c("i", { staticClass: "feather icon-user-plus" }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.following === true
              ? _c("span", [
                  _vm._v(_vm._s(_vm.__("globals.unfollow")) + " "),
                  _c("i", { staticClass: "feather icon-log-out" }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.following === "pending"
              ? _c("span", [
                  _vm._v(_vm._s(_vm.__("globals.requested")) + " "),
                  _c("i", { staticClass: "feather icon-log-in" }),
                ])
              : _vm._e(),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }